import { render, staticRenderFns } from "./RequestStructureSection.vue?vue&type=template&id=346cfb80&"
import script from "./RequestStructureSection.vue?vue&type=script&lang=js&"
export * from "./RequestStructureSection.vue?vue&type=script&lang=js&"
import style0 from "./RequestStructureSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports